import { IMessage } from "@endpoints/types/message.type";
import dayjs from "@lib/dayjs";
import { RootState } from "@store/reducers";
import { EnumUserTypes } from "@utils/constants";
import { useSelector } from "react-redux";

type MessageBubbleProps = {
  item: IMessage;
  receiverDetails: any;
};

const MessageBubble = ({ item, receiverDetails }: MessageBubbleProps) => {
  const user = useSelector((state: RootState) => state.auth.user);
  const isSender = item?.createdBy === (user?.userType === EnumUserTypes.CANDIDATE ? user?.userId : user?._id);
  const displayName = isSender ? (user?.firstName + ' ' + user?.lastName) : (receiverDetails?.name)
  // (user?.userType === EnumUserTypes.RECRUITER ? user?._id : user?.userId);

  return (
    <div
      className={`flex flex-col w-[60%] rounded-md p-3 gap-2 ${isSender ? "bg-white ml-auto" : "bg-[#F1F5F9] mr-auto"
        }`}
    >
      {/* {user?._id} */}
      <div className="flex items-center w-max">
        <span className="text-[10px] text-light-black font-medium">
          {dayjs(item?.createdAt).format("hh:mm a DD MMM")}
        </span>
        <span className="text-[10px] font-semibold text-light-black">
          &nbsp; -&nbsp; {displayName}
        </span>
      </div>
      <span className={`text-xs font-medium text-charcoal ${isSender ? "" : ""}`}>
        {/* Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
        tempor incididunt ut labore et dolore magna aliqua. */}
        {item?.message}
      </span>
    </div>
  );
};

export default MessageBubble;
